<template>
  <div class="container">
        首页
   
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>

<style scoped>
  .container {}
</style>
